<template>
  <div
    class="content-devx"
  >
    <f7-block class="margin-bottom-title">
      <f7-row>
        <f7-col width="20">
          {{ $t('Application') }}
        </f7-col>
        <f7-col width="80" />
      </f7-row>
    </f7-block>
    <f7-block>
      <f7-row class="margin-bottom">
        <f7-col width="50">
          <f7-row class="margin-bottom">
            {{ $t('Main_Elements') }}
          </f7-row>
          <f7-row />
          <DxDataGrid
            id="mainElements-grid"
            :data-source="[application]"
            :column-min-width="90"
            :column-auto-width="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
          >
            <DxColumn
              data-field="NT"
              caption="NT"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="P2015_Total"
              caption="P2015_Total"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="K2O"
              caption="K20"
              :allow-header-filtering="true"
              alignment="left"
            />
          </dxdatagrid>
        </f7-col>
        <f7-col width="50">
          <f7-row class="margin-bottom">
            {{ $t('Secondary_Elements') }}
          </f7-row>
          <f7-row>
            <DxDataGrid
              id="secondaryElements-grid"
              :data-source="[application]"
              :column-min-width="90"
              :column-auto-width="true"
              :show-borders="true"
              :show-column-lines="true"
              :show-row-lines="true"
            >
              <DxColumn
                data-field="CaO"
                caption="CaO"
                :allow-header-filtering="false"
                alignment="left"
              />
              <DxColumn
                data-field="MgO"
                caption="MgO"
                :allow-header-filtering="false"
                alignment="left"
              />
              <DxColumn
                data-field="SO3"
                caption="SO3"
                :allow-header-filtering="false"
                alignment="left"
              />
            </Dxdatagrid>
          </f7-row>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="50">
          <f7-row>
            {{ $t('Microelements') }}
          </f7-row>
          <f7-row>
            <DxDataGrid
              id="microelements-grid"
              :data-source="[application]"
              :column-min-width="90"
              :column-auto-width="true"
              :show-borders="true"
              :show-column-lines="true"
              :show-row-lines="true"
            >
              <DxColumn
                data-field="B"
                caption="B"
                :allow-header-filtering="false"
                alignment="left"
              />
              <DxColumn
                data-field="Cu"
                caption="Cu"
                :allow-header-filtering="true"
                alignment="left"
              />
              <DxColumn
                data-field="Fe"
                caption="Fe"
                :allow-header-filtering="false"
                alignment="left"
              />
              <DxColumn
                data-field="Mn"
                caption="Mn"
                :allow-header-filtering="false"
                alignment="left"
              />
              <DxColumn
                data-field="Zn"
                caption="Zn"
                :allow-header-filtering="false"
                alignment="left"
              />
              <DxColumn
                data-field="Se"
                caption="Se"
                :allow-header-filtering="false"
                alignment="left"
              />
            </Dxdatagrid>
          </f7-row>
        </f7-col>
        <f7-col width="50" />
      </f7-row>
    </f7-block>
  </div>
</template>
<script>

import {
  DxDataGrid,
  DxColumn,
} from 'devextreme-vue/data-grid';

export default {
  name: 'Application',
  components: {
    DxDataGrid,
    DxColumn,
  },
  props: {
    application: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import './Application.styles.scss';
</style>
